/**
 * ForgotPasswordPage — autenticazione Phase 6 (IMPL-P6-001).
 *
 * UC-008 step 1 page. Wraps the {@link ForgotPasswordForm} inside the
 * standard auth chrome. Footer links back to `/accedi` so users who recall
 * their credentials can return without re-routing manually.
 */
import { Link } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { AuthCard } from '../components/AuthCard';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm';

export function ForgotPasswordPage() {
  return (
    <AuthLayout>
      <AuthCard
        title="Password dimenticata"
        description="Inserisci la tua email: se l'indirizzo è registrato ti invieremo un link per reimpostare la password."
        footer={
          <p className="text-muted-foreground">
            Hai ricordato la password?{' '}
            <Link
              to="/accedi"
              className="font-medium text-primary underline-offset-4 hover:underline"
            >
              Torna al login
            </Link>
          </p>
        }
      >
        <ForgotPasswordForm />
      </AuthCard>
    </AuthLayout>
  );
}
